<template>
  <v-dialog
    :value="value"
    :max-width="maxWidth"
    :persistent="persistent || loading"
    @input="onDialogInput"
  >
    <v-card class="delete-confirm-card">
      <div class="delete-confirm-header">
        <div v-if="showIcon" class="delete-confirm-icon-wrap">
          <v-icon class="delete-confirm-icon" :color="iconColor">{{
            icon
          }}</v-icon>
        </div>
        <div>
          <h3 class="delete-confirm-title">{{ title }}</h3>
          <p v-if="subtitle" class="delete-confirm-subtitle">{{ subtitle }}</p>
        </div>
      </div>

      <v-card-text class="delete-confirm-body">
        <p class="delete-confirm-message">{{ message }}</p>
        <p v-if="warning" class="delete-confirm-warning">{{ warning }}</p>
      </v-card-text>

      <div class="delete-confirm-footer">
        <v-btn
          class="delete-confirm-cancel"
          flat
          small
          :disabled="loading"
          @click="closeDialog"
        >
          {{ cancelText }}
        </v-btn>
        <v-btn
          class="delete-confirm-action"
          small
          :color="confirmColor"
          :loading="loading"
          :disabled="loading"
          @click="$emit('confirm')"
        >
          <v-icon v-if="confirmIcon" left small>{{ confirmIcon }}</v-icon>
          {{ confirmText }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteConfirmDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Eliminar registro',
    },
    subtitle: {
      type: String,
      default: 'Esta accion no se puede deshacer',
    },
    message: {
      type: String,
      default: 'Confirma si deseas continuar con esta eliminacion.',
    },
    warning: {
      type: String,
      default: '',
    },
    cancelText: {
      type: String,
      default: 'Cancelar',
    },
    confirmText: {
      type: String,
      default: 'Eliminar',
    },
    confirmColor: {
      type: String,
      default: '#E5252A',
    },
    confirmIcon: {
      type: String,
      default: 'delete_forever',
    },
    icon: {
      type: String,
      default: 'warning',
    },
    iconColor: {
      type: String,
      default: '#E5252A',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: [String, Number],
      default: 460,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onDialogInput(value) {
      this.$emit('input', value)
    },
    closeDialog() {
      this.$emit('input', false)
      this.$emit('cancel')
    },
  },
}
</script>

<style scoped>
.delete-confirm-card {
  border-radius: 14px !important;
  overflow: hidden;
}

.delete-confirm-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 22px 16px;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(180deg, #fff5f5 0%, #ffffff 100%);
}

.delete-confirm-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(229, 37, 42, 0.12);
  border: 1px solid rgba(229, 37, 42, 0.22);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.delete-confirm-icon {
  font-size: 22px !important;
}

.delete-confirm-title {
  margin: 0 0 2px;
  font-size: 17px;
  line-height: 1.3;
  font-weight: 700;
  color: #172133;
}

.delete-confirm-subtitle {
  margin: 0;
  font-size: 12px;
  color: #64748b;
}

.delete-confirm-body {
  padding: 16px 22px !important;
}

.delete-confirm-message {
  margin: 0;
  color: #334155;
  font-size: 14px;
  line-height: 1.6;
}

.delete-confirm-warning {
  margin: 10px 0 0;
  color: #7f1d1d;
  font-size: 12.5px;
  line-height: 1.5;
}

.delete-confirm-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 22px 18px;
  border-top: 1px solid #eef2f7;
}

.delete-confirm-cancel {
  border: 1px solid #e2e8f0 !important;
  background: #ffffff !important;
  color: #475569 !important;
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  box-shadow: none !important;
}

.delete-confirm-action {
  color: #ffffff !important;
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  box-shadow: none !important;
}
</style>
